module.exports = __webpack_public_path__ + "img/highway.1b059338.svg";